import { useCallback, useEffect, useState } from "react";
import {
  fetchCoachClientAndProgramTotals,
} from "../lib/coachTableCounts.js";
import { useAuthUserId } from "./useAuthUserId.js";

export function useCoachTableCounts() {
  const { userId, authLoading } = useAuthUserId();
  const [clientTotal, setClientTotal] = useState(0);
  const [programTotal, setProgramTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState( (null));
  const [refreshToken, setRefreshToken] = useState(0);

  const refetch = useCallback(() => {
    setRefreshToken((t) => t + 1);
  }, []);

  useEffect(() => {
    let cancelled = false;

    if (authLoading) return;

    if (!userId) {
      setClientTotal(0);
      setProgramTotal(0);
      setError(null);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);

    (async () => {
      try {
        const { clientTotal: c, programTotal: p } =
          await fetchCoachClientAndProgramTotals(userId);
        if (!cancelled) {
          setClientTotal(c);
          setProgramTotal(p);
        }
      } catch (e) {
        if (!cancelled) {
          setError(e?.message ?? String(e));
          setClientTotal(0);
          setProgramTotal(0);
        }
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [userId, authLoading, refreshToken]);

  return { clientTotal, programTotal, isLoading, error, refetch };
}
